import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@/assets/icons/ArrowRightIcon';

export interface DashboardLinkCardProps {
  to: string;
  /** Small first line, e.g. "Explore our". */
  lead: string;
  /** Green second line naming the destination, e.g. "Trusted Partners". */
  title: string;
}

/**
 * Side-column entry card on the member dashboard: two lines of copy and an
 * arrow, the whole card one link. Used for Trusted Partners (UX sheet,
 * StartupAdminVF r10/r19) and Startup Perks (MYN-252).
 */
export function DashboardLinkCard({ to, lead, title }: DashboardLinkCardProps) {
  return (
    <Link
      to={to}
      className="flex min-h-[6.25rem] w-full cursor-pointer items-center justify-between gap-4 rounded-card border border-navy/10 bg-white p-6 shadow-[var(--card-shadow)] transition-colors hover:border-green focus-visible:ring-2 focus-visible:ring-green focus-visible:outline-none"
    >
      <div className="flex flex-col gap-1.5">
        <p className="text-[1.125rem] leading-[1.42rem] font-medium text-navy">{lead}</p>
        <p className="text-[1.25rem] leading-[1.42rem] font-semibold text-green">{title}</p>
      </div>
      <span className="flex size-[2.625rem] shrink-0 items-center justify-center rounded-full bg-green pl-0.5">
        <ArrowRightIcon size={16} className="text-white" />
      </span>
    </Link>
  );
}
